// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2DstN","alert":"SettungsInbox_alert__1NTPT"};